import React from 'react';
import { trans } from '@spotahome/soyuz/client';

const SaturationMessage = () => {
  return (
    <p className="contact-us__saturation">{trans('contact_us.saturation')}</p>
  );
};

export default SaturationMessage;
